export default __webpack_public_path__ + "static/bg-f67a3fdccd395441662a87fd6c4d3473.png";